<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>{{ customerInfo.cs_Name }}</span>
        <q-badge color="red" text-color="white" :label="customerInfo.Cs_Code" align="top"/>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <apexchart
          :options="customerChartOptions"
          height="300"
          :series="customerChartSeries"></apexchart>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CustomerRFMTrace",
  props: {
    customerInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      items: [],
      customerChartOptions: {
        chart: {
          id: 'buyLastPrice',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'اعتبار مشتری',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            show: false,
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
        yaxis:{
          labels:{
            show:false
          }
        }
      },
      customerChartSeries: [{
        name: 'اعتبار مشتری',
        data: []
      }],
    }
  },
  methods: {
    ...mapActions({
      getData: 'Customers/getCustomerRFMTrace'
    })
  },
  created() {
    this.getData(this.customerInfo.Cs_ID).then((res) => {
      this.items = res
      // this.customerChartOptions = {
      //   xaxis: {
      //     categories: []
      //   }
      // }
      this.customerChartSeries = [{
        data: [...new Set(res.filter(item => item.CustomerValue).map(item => item.CustomerValue))]
      }]
    })
  }
}
</script>

<style scoped>

</style>